import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { JiraLinkAutomationDiscoveryDialogProps } from '../src/JiraLinkAutomationDiscoveryDialog.tsx';

export const LazyJiraLinkAutomationDiscoveryDialog: LoadableType<
	JiraLinkAutomationDiscoveryDialogProps & DialogsContainerProps
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-JiraLinkAutomationDiscoveryDialog" */ '../src/JiraLinkAutomationDiscoveryDialog.tsx'
			)
		).JiraLinkAutomationDiscoveryDialog,
});
